import get from 'lodash.get';
import { getTheme } from './themes.js';

/**
 * Checks if a theme path exists in our theme object
 *
 * Example
 * ```
 * isThemePath('colors.gray.100') // => true
 * isThemePath('wat') // => false
 * ```
 */
function isValidThemePath(path) {
  var theme = getTheme('light');
  var token = get(theme, path);
  return token !== undefined;
}

export { isValidThemePath };
